
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStagePrzesunZadanieGold(draggedId,targetId,procesorId,dropDate,refreshGantAll) {

// id = procesor id
console.log("dropDate22:" + dropDate)
  
  axios
  .get(IP + "API_0015_gant_procedura_przesun_zadanie_gold/"+draggedId+"/"+targetId+"/"+procesorId+"/"+dropDate+"/" + sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })
}

//   +"/" + sessionStorage.getItem("token")

